import PropTypes from 'prop-types';

import { articleSerializer } from './articleSerializer';

const withDeserializedArticle = (Component) => {
  const C = (props) => {
    const { article } = props;
    let deserializedArticle;

    if (article) {
      const nodes = articleSerializer.deserialize(article.block);
      deserializedArticle = {
        document: {
          nodes: nodes.filter((node) => !!node),
        },
      };
    } else {
      deserializedArticle = null;
    }

    return <Component deserializedArticle={deserializedArticle} {...props} />;
  };

  C.propTypes = {
    article: PropTypes.object,
  };

  C.displayName = `withDeserializedArticle(${
    Component.displayName || Component.name
  })`;

  return C;
};

export { withDeserializedArticle };
